import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { format } from 'date-fns';
import styles from './LeaveModal.module.scss';
import { createLeaveAction } from '../../actions/leave';
import { LEAVE_TYPE_OPTIONS } from '../../constants/leave';
import type { LeaveTypeValue } from '../../types/leave';

type Props = {
  onClose: () => void,
  onCreated?: () => void,
};

const LeaveModal = ({ onClose, onCreated }: Props) => {
  const dispatch = useDispatch();
  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');
  const [leaveType, setLeaveType] = useState<LeaveTypeValue>('paid_leave');
  const [leaveTypeComment, setLeaveTypeComment] = useState<string>('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const commentOk = leaveType !== 'other'
    || (leaveTypeComment.trim().length > 0 && leaveTypeComment.trim().length <= 2000);
  const canSubmit = Boolean(
    startDate && endDate && leaveType && commentOk && !isSubmitting,
  );

  const handleSubmit = async () => {
    if (!canSubmit) return;
    setIsSubmitting(true);
    const payload: Record<string, unknown> = {
      startDate: new Date(`${format(new Date(startDate), 'yyyy-MM-dd')}T00:00:00.000Z`).toISOString(),
      endDate: new Date(`${format(new Date(endDate), 'yyyy-MM-dd')}T00:00:00.000Z`).toISOString(),
      leaveType,
    };
    if (leaveType === 'other') {
      payload.leaveTypeComment = leaveTypeComment.trim();
    }
    await createLeaveAction(dispatch as any, payload);
    setIsSubmitting(false);
    onCreated?.();
    onClose();
  };

  return (
    <div className={styles.container}>
      <h4>Nouvelle demande de congés</h4>
      <div className={styles.field}>
        <label>Type de congés</label>
        <select
          value={leaveType}
          onChange={(e) => {
            const v = e.target.value as LeaveTypeValue;
            setLeaveType(v);
            if (v !== 'other') setLeaveTypeComment('');
          }}
        >
          {LEAVE_TYPE_OPTIONS.map((o) => (
            <option key={o.value} value={o.value}>{o.label}</option>
          ))}
        </select>
      </div>
      {leaveType === 'other' && (
        <div className={styles.field}>
          <label htmlFor="leave-type-comment">Précisez le motif (obligatoire)</label>
          <textarea
            id="leave-type-comment"
            rows={3}
            maxLength={2000}
            value={leaveTypeComment}
            onChange={(e) => setLeaveTypeComment(e.target.value)}
            placeholder="Décrivez le type d'absence ou le motif."
          />
        </div>
      )}
      <div className={styles.field}>
        <label>Date de début</label>
        <input
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
        />
      </div>
      <div className={styles.field}>
        <label>Date de retour</label>
        <input
          type="date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
        />
      </div>
      <div className={styles.actions}>
        <button type="button" className="secondary" onClick={onClose}>
          Annuler
        </button>
        <button type="button" disabled={!canSubmit} onClick={handleSubmit}>
          Créer
        </button>
      </div>
    </div>
  );
};

export default LeaveModal;
